import React, { Component } from 'react';
import Router from 'next/router';
import LinkAnchor from '../../Links/LinkAnchor';

import config from '../../../config';

const { appHost } = config;

class Explore extends Component {
    constructor() {
        super();
        this.state = {};
    }

    prismicRedirect(url) {
        console.log('prismicRedirect', url);
        if (url.startsWith('http')) {
            // external urls, like support page
            window.location = url;
        } else if (url.startsWith('app:')) {
            // links pointing to the utr app
            window.location = url.replace('app:', appHost);
        } else {
            // internal routing within marketing app
            Router.push(url);
        }
    }

    render() {
        const bgImg = (imageObj) => {
            if (imageObj && imageObj.oneX && imageObj.twoX && imageObj.threeX) {
                return (
                    <img
                        src={imageObj.default}
                        srcSet={`${imageObj.oneX} 1x, ${imageObj.twoX} 2x, ${imageObj.threeX} 3x`}
                        style={{ left: '0%' }}
                    />
                );
            } if (imageObj && imageObj.default) {
                return (
                    <img
                        src={imageObj.default}
                        style={{ left: '0%' }}
                    />
                );
            }
            return null;
        };

        const title = this.props.title || 'What are you looking for?';
        const { className } = this.props;

        return (
            <div className={`container ${className}`}>
                <div className={`d-block d-md-none mt16`}>
                    <div className={`fs18 text-medium text-dark mb8 ${this.props.titleclass}`}>
                        {title}
                    </div>
                    <div className="row">
                        <div className="col-12 d-flex x-scroll hide-scroll">
                            {this.props.exploreItems && this.props.exploreItems.map((exploreItem, i) => {
                                const mobileBg = exploreItem.image && exploreItem.image.mobile;

                                return (
                                    <LinkAnchor
                                        key={`exploreItem-${i}`}
                                        href={exploreItem.link}
                                    >
                                        <div className="utr-card button-card button-card-mobile clickable mb40">
                                            <div className="background-wrapper">
                                                <picture className="img">
                                                    {bgImg(mobileBg)}
                                                </picture>
                                                <div className="button-card-overlay">
                                                    {/* <p>{exploreItem.imagename}</p> */}
                                                </div>
                                            </div>
                                            <div className="button-card-title ellipsis">
                                                {exploreItem.title}
                                            </div>
                                        </div>
                                    </LinkAnchor>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className={`d-none d-md-block mt40`}>
                    <div className={`fs24 text-medium text-dark mb8 ${this.props.titleclass}`}>
                        {title}
                    </div>
                    <div className="row">
                        {this.props.exploreItems && this.props.exploreItems.map((exploreItem, i) => {
                            const desktopBg = exploreItem.image && exploreItem.image.desktop;
                            const mobileBg = exploreItem.image && exploreItem.image.mobile;

                            return (
                                // eslint-disable-next-line react/no-array-index-key
                                <div className={`col-12 ${this.props.exploreItems.length === 3 ? 'col-md-4' : 'col-md-3'}`} key={`exploreItem-${i}`}>
                                    <LinkAnchor
                                        key={`exploreItem-${i}`}
                                        href={exploreItem.link}
                                    >
                                        <div className="utr-card button-card clickable mb40">
                                            <div className="background-wrapper">
                                                <picture className="img d-none d-sm-block">
                                                    {bgImg(desktopBg)}
                                                </picture>
                                                <picture className="img d-block d-sm-none">
                                                    {bgImg(mobileBg)}
                                                </picture>
                                                <div className="button-card-overlay">
                                                    {/* <p>{exploreItem.imagename}</p> */}
                                                </div>
                                            </div>
                                            <div className="button-card-title">
                                                {exploreItem.title}
                                            </div>
                                        </div>
                                    </LinkAnchor>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default Explore;
